$(document).ready(function(){
// Slider for the cart drawer products
    setInterval(function() {
    jQuery('.inner-wrp').not('.slick-initialized').slick({
      dots: true,
      arrows:true,
      infinite: true,
      speed: 300,
      // centerMode: true,
      // centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    }, 500);
  // code for the check if total price is greater then assigned customizer price
  setInterval(function() {
    // Guard: the gift-threshold price element (and its data-* attrs) may not exist on
    // every page / empty cart. Bail out quietly instead of throwing on undefined.replace().
    var $priceEl = $('.for_gift_threshold span.compare-price');
    if (!$priceEl.length) return;

    var cartPriceAttr = $priceEl.attr('data-cart-price');
    var totalPriceAttr = $priceEl.attr('data-total-price');
    if (cartPriceAttr == null || totalPriceAttr == null) return;

    var totalcartprice = parseFloat(cartPriceAttr.replace(/,/g, ''));
    var settingsCartPrice = parseFloat(totalPriceAttr.replace(/,/g, ''));

         if (totalcartprice <= settingsCartPrice) {
          $('.gift-message').removeClass('hidden');
      } else {
          $('.gift-message').addClass('hidden');
      }
    }, 1000);
// code for the check if total price is greater then assigned customizer price

});